import { React, useEffect, useRef, useState } from 'react';
import { Row, Col, Button, Space, message, Form, Tag } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, useParams, } from 'react-router-dom'
import { default as ProTableOT } from "../../../../utility/ProTable_ot";
import StudentCard from '../Component/StudentCard';


const StudentCheckInDetailOverView = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const actionRef = useRef()
    const [loading, set_loading] = useState(0);
    const [open, setOpen] = useState(false);
    const [datas, setDatas] = useState([])
    const [classDatas, setClassDatas] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [axiosMode, setAxiosMode] = useState("get")
    const reload = () => {
        actionRef.current.reloadAndRest();
    }
    const addDatas = () => {
        setOpen(true)
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                reload()
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                reload()
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                reload()
                // setSelectedRowsInfo([])
            }
            else if (axiosMode === "get") {
                setDatas(values.data);
                set_loading(false)
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                reload()
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                reload()
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const onClick = (val) => {
        console.log(val)
    }
    useEffect(() => {
        setDatas([
            {
                title: 1
            },
            {
                title: 2
            }
        ])
        setClassDatas([
            {
                title: "班級",
                value: "海豚班"
            },
            {
                title: "課程",
                value: "課程3"
            },
            {
                title: "老師",
                value: "無名氏"
            },
            {
                title: "日期",
                value: "2023/11/23"
            },
            {
                title: "上課時段",
                value: { week_name: "三", time_start: "18:00", time_end: "20:30" }
            }
        ])
    }, []);
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    {classDatas.length && classDatas.map(tmp => (
                        <Col span={8} style={{ padding: "1%" }}>
                            {tmp.title !== "上課時段" ?
                                `${tmp.title}：${tmp.value}`
                                :
                                `${tmp.title}： 星期${tmp.value.week_name} ${tmp.value?.time_start}-${tmp.value?.time_end}`
                            }
                        </Col>
                    ))}
                </Row>
            </Col>
            <Col span={24}>
                <Row gutter={[8, 16]}>
                    {datas.map(tmp => (
                        <Col span={6}>
                            <StudentCard
                                data={{
                                    name: "姓名",
                                    src: "https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png",
                                    checkIn: true
                                }}
                                onClick={onClick}
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    )
}
export default StudentCheckInDetailOverView;